import React from 'react';
import { NewBorderStyle } from './NewBorder.styles';

export default function NewBorder({ styles }) {
  return <NewBorderStyle style={styles} />;
}
